import React from 'react'
import '../../styles/mdx.scss'

export default function Grid4({ children }) {
  return (
    <div className="mdx">
        <div className="mdx__grid4">
            { children }
        </div>
    </div>
  )
}
